<template>
    <v-container fluid class="">
        <div class="dashboard-page">
            <v-list>
                <v-list-item v-for="(item, i) in datos"
                             :key="i">
                    <v-list-item-title>{{item}}</v-list-item-title>
                </v-list-item>
            </v-list>
            <v-row>

                <v-col cols=12>
                    <v-card class="daily-line ma-1">
                        <v-card-title class="pa-5 pb-3 justify-center font-weight-bold">
                            <p v-html="desc" style="text-align: center; font-size: 20px; font-weight: 700; margin-top: 2%; ">Validación inicial de documentos</p>

                        </v-card-title>
                        <v-card-text class="justify-center pa-4 pb-0">
                            
                            <table id="tblDocs" style="margin: auto; width: 50%; margin-top: 3%;">
                                <tbody>
                                    <tr>
                                        <td>
                                            <p class="justify-center font-weight-bold" style="font-size: 1.5em"> Documentos</p>
                                        </td>
                                        <td style="padding-left: 25%;">
                                            <p class="font-weight-bold" style="width: 120px; font-size: 1.5em;">Los tiene</p>
                                        </td>
                                    </tr>
                                    <template>
                                        <tr v-for="(item,index) in documentos" :key="index" style="border-bottom-width: unset;">
                                            <td v-bind:id="item.doclave" style="font-size: 1.3em;">{{item.dodescrip}}</td>
                                            <td style="padding-left: 24%;">
                                                <!--<v-checkbox :on-icon="'mdi-check-circle-outline'"
                                                            :off-icon="'mdi-checkbox-blank-circle-outline'">

                                                </v-checkbox>-->
                                                <v-btn-toggle v-model="resp[index]"
                                                              tile
                                                              color="blue darken-1 accent-3"
                                                              group>
                                                    <v-btn value="S">
                                                        Si
                                                    </v-btn>

                                                    <v-btn value="N">
                                                        No
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </td>
                                        </tr>

                                    </template>
                                </tbody>
                            </table>

                            <v-card-actions class="justify-center" style="margin-bottom: 5%; margin-top: 5%;">
                                <v-btn depressed
                                       color="primary" elevation="5" @click="obtenerTotal">
                                    Guardar
                                </v-btn>
                            </v-card-actions>

                            <v-dialog v-model="dialog3" max-width="500px">
                                <v-card>
                                    <v-card-title>
                                        <span>Registrado con ex�to</span>
                                        <!--<p style="text-align: center; font-size: 20px; font-weight: 700; margin-top: 2%; ">Validaci�n inicial de documentos</p>-->
                                        <v-spacer></v-spacer>
                                    </v-card-title>
                                    <v-card-actions class="justify-center">
                                        <v-btn color="primary" @click="dialog3=false, reloadPage();">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="noComplete" max-width="500px">
                                <v-card>
                                    <v-card-title>
                                        <span>Selecciona todas las opciones</span>
                                        <!--<p style="text-align: center; font-size: 20px; font-weight: 700; margin-top: 2%; ">Selecciona todas las opciones</p>-->
                                        <v-spacer></v-spacer>
                                    </v-card-title>
                                    <v-card-actions class="justify-center">
                                        <v-btn color="primary" @click="noComplete=false;">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>


<script>
    import { mapState } from 'vuex';
    import ApexChart from 'vue-apexcharts';
    import Documentos from '@/services/Documentos/documentos.service.js';
    import dash from '@/services/Dashboard/Dashboard.service.js';

    export default {
        components: {
            ApexChart
        },
        data() {
            return {

                apexLoading: false,
                total: 0,
                vehiculos: [],
                documentos: [],
                conductores: [],
                asistencia: [],
                asuntosrelevantes: [],
                datos: [],
                resp: [],
                dialog3: false,
                noComplete: false,
                desc: "Validación inicial de documentos"

            };
        },

        methods: {
            
            obtenerTotal() {
                var table = document.getElementById('tblDocs');
                var str = '';

                for (var i = 0; this.resp.length > i; i++)
                {

                    if (this.resp[i] == undefined) {
                        this.noComplete = true;
                        return;
                    }
                    
                } 
                
                if (this.resp.length == table.rows.length - 1) {
                    for (var r = 1, n = table.rows.length; r < n; r++) {
                        str = str + table.rows[r].cells[0].id + ':' + this.resp[r - 1] + ',';
                        
                    }
                    
                    var formData = new FormData();
                    formData.append("nrreporte", "109837");
                    formData.append("svindice", "2");
                    formData.append("vacadena", str);
                    this.axios.post(`${this.domain.domainNameForApi}Documentos/InsertarHistorial`, formData).then(response => {
                        this.dialog3 = true;
                    })
                }
                else {
                    this.noComplete = true;
                }
                
                    
                



            },
            reloadPage() {
                window.location.reload();
            }
        },

        created: function () {
            this.getdata();
            this.asistencianot();
            this.AsistenciaAnio();
        },

        computed: {
            ...mapState(["domain", "theme"]),
            ...mapState("Operacion", ["key"]),

        },
        mounted() {

            var formData = new FormData();
                //formData.append("nrreporte", this.reporte.nrreporte);
                //formData.append("svindice", this.reporte.svindice);
            Documentos.ObtenerListaDocs(this, formData).then(data => {

                this.documentos = data;

            });

            setTimeout(() => {
                this.apexLoading = true
            });

            dash.obtenerAsistencia(this);
            dash.obtenerConductor(this);
            dash.ObtenerVehiculos(this);
            dash.obtenerAsuntosRelevantes(this);
        }

    };
</script>
<!--<style src="./src/components/pages/main/Dashboard.scss" lang="scss" />-->